import { create } from 'zustand'

// create a zustand store for users
export const useCompaniesStore = create((set) => ({
  companies: [],
  handleCompanies: (companies) => set(() => ({ companies })),
}))
